import { takeEvery, getContext, call, select } from 'redux-saga/effects';
import { RootAction } from 'store/state';
import { MUTATE, SET_MUTATION_RESPONSE } from 'store/state/mutationsResponse/types';
import { MutationType } from 'store/sagas/apiService/types';
import { DealType } from 'utils/entities';
import { getRouteParams } from 'store/state/selectors/router';
import { SetMutationResponseAction } from 'store/state/mutationsResponse/actions';
import { pageSourceToAnalytics } from 'components/upload-bulletin/report-error-popup/helpers';


const reportAddressPattern = (action: RootAction) => action.type === MUTATE && action.mutationType === MutationType.UploadBulletinBadAddressReport;
const reportAddressSuccessPattern = (action: RootAction) => action.type === SET_MUTATION_RESPONSE && action.mutationType === MutationType.UploadBulletinBadAddressReport;

function* reportAddressWorker(action: RootAction) {
  let variables = null;
  if (action.type === MUTATE && action.mutationType === MutationType.UploadBulletinBadAddressReport) {
    variables = action.meta.variables;
  }
  if (!variables) return;

  const { extraData: { reportSource, dealType, id, message, email } } = variables;
  const { sendEvent } = yield getContext('analytics');
  const { source } = yield select(getRouteParams);

  yield call(sendEvent, 'bulletin_manage_error_report_form_submit', 'bulletin_manage', {
    property: {
      deal_type: dealType === DealType.Buy ? 'for_sale' : 'for_rent',
      property_id: id || 'newListing',
    },
    event: {
      source: pageSourceToAnalytics[source] || 'other',
      report_source: reportSource,
      email,
      message: (message || '').substring(0, 500),
    },
  });
}

function* reportAddressSuccessWorker(action: SetMutationResponseAction<MutationType.UploadBulletinBadAddressReport>) {
  const { data } = action.meta.response;

  if (!data || !data.badAddressReport) return;

  const { extraData: { reportSource, dealType, id, message, email } } = action.meta.variables;

  const { sendEvent } = yield getContext('analytics');
  const { source } = yield select(getRouteParams);

  yield call(sendEvent, 'bulletin_manage_error_report_form_submit_success', 'bulletin_manage', {
    property: {
      deal_type: dealType === DealType.Buy ? 'for_sale' : 'for_rent',
      property_id: id || 'newListing',
    },
    event: {
      source: pageSourceToAnalytics[source] || 'other',
      report_source: reportSource,
      email,
      message: (message || '').substring(0, 500),
    },
  });
}

export function* uploadListingReportAddressWorker() {
  yield takeEvery(reportAddressPattern, reportAddressWorker);
  yield takeEvery(reportAddressSuccessPattern, reportAddressSuccessWorker);
}
